export default __webpack_public_path__ + "static/media/yellow_circle.94b46e31.png";